import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBase } from 'src/app/_models/form-base';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-search-field',
    templateUrl: './search-field.component.html',
    styleUrl: './search-field.component.scss',
    imports: [FormsModule, ReactiveFormsModule, MatIcon],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFieldComponent {
  /** Form base (required) */
  field = input<FormBase<string>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Output click event */
  buttonClicked = output<string>();

  clickButton = (action: string): void => {
    this.buttonClicked.emit?.(action);
  };
}
